import { useState } from 'preact/hooks';
import { t } from '../i18n/index.js';
import { BingoAdmin } from './admin/BingoAdmin.js';

/**
 * The bingo host's page (user request 2026-10-01): a player given the permission runs the bingo
 * (batches, games, settings) like the administrator. The administrator can take the permission
 * away at any time – then the page closes; a running automatic game goes on.
 */
export function BingoHostView() {
  const [revoked, setRevoked] = useState(false);
  const h = t.bingoHost;
  if (revoked) {
    return (
      <section class="card">
        <h2>{h.revokedTitle}</h2>
        <p>{h.revokedText}</p>
        <a class="btn btn-primary" href="#/">
          {h.back}
        </a>
      </section>
    );
  }
  return (
    <div class="stack">
      <section class="card">
        <h2>{h.title}</h2>
        <p class="hint">{h.info}</p>
      </section>
      <BingoAdmin onForbidden={() => setRevoked(true)} />
    </div>
  );
}
